/*
* 项目进度日志组件
*/

import { Component } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import {
    Row,
    Col,
    message,
    Table,
    Select,
    Button,
    Progress,
    Tooltip,
    Space,
    DatePicker,
    Tag,
} from 'antd';
import { generate } from '@ant-design/colors';
import { ExportOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    DateFormat,
    ShowIPModal,
    isGTscreenWidth,
    GetArrSpanMaxWidth,
    GetDropdownActionName,
    rootReactDom,
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import DetailProgressEntity from './DetailProgressLogEntity.js';

const Option = Select.Option;
const MODULENAME = CNF.navItems[0].submenu[3].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[0].submenu[3].ptn;

const { RangePicker } = DatePicker;

const twoColors = {
    '0%': '#108ee9',
    '100%': '#87d068',
};

const Lists = (props) => {

    const update = (record) => {
        rootReactDom && rootReactDom.render(
            <DetailProgressEntity
                isRefresh={props.isRefresh}
                preGroup={props.preGroup}
                btnLists={props.btnLists}
                open={true}
                record={record}
                action={CNF.actionName.UPDATE}
            />);
    }

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = (action, record) => {
        let uri = 'project/progressLogs/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.project_name, action, MODULENAME, props.isRefresh, uri);
                break
            default:
                break;
        }
    }

    const columns = [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        { title: '项目名称', dataIndex: 'name', key: 'name', fixed: 'left', width: GetArrSpanMaxWidth(props.dataLists, 'name'), },
        { title: '项目阶段', dataIndex: 'phase', key: 'phase', width: 120, },
        {
            title: '项目进度', key: 'progress', width: 180,
            render: (record) => <Progress style={{ margin: 0, width: '80%' }} size='small' percent={record.progress} strokeColor={twoColors} />
        },
        {
            title: '进度状态', key: 'node_status', width: 120,
            render: (record) => <Tag style={{ width: 52, color: record.node_color, textAlign: 'center' }} variant='filled' size='small' color={generate(record.node_color)[0]}>{record.node_status}</Tag>
        },
        {
            title: '进度说明', key: 'description', minWidth: 200, maxWidth: 300, ellipsis: true,
            render: (record) => < Tooltip placement='top' title={< span > {record.description}</span >}>{record.description}</Tooltip >
        },
        { title: '记录时间', dataIndex: 'record_time', key: 'record_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '记录者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        {
            title: '', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: (
                props.btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + 'delete') > 0
            ) ? false : true,
            render: (record) => GetDropdownActionName(props.btnLists, MODULENAME_PTN, record, operation)
        }
    ];
    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={props.dataLists}
                pagination={{
                    showSizeChanger: false,
                    // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                    showQuickJumper: false,
                    showTotal: () => `共${props.pageCount > 10000 ? (props.pageCount / 10000).toFixed(CNF.DPL) + '万' : props.pageCount}条`,
                    pageSize: CNF.pageSize,
                    current: props.currentIndex,
                    total: props.pageCount,
                    onShowSizeChange: (current, pageSize) => props.changePageSize(pageSize, current),
                    onChange: (current) => props.changeIndex(current),
                }}
            />
        </>
    );
}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: null,
            isModalOpen: false,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            projectUlid: '',
            projectLists: [],
            startDate: '',
            endDate: '',
        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeProjectUlid = (value) => { this.setState({ projectUlid: value === undefined ? '' : value }); this.search(); }
    changeTimeInterval = (_, dateString) => { this.setState({ startDate: dateString[0], endDate: dateString[1] }); this.search(); };
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }

    setOpen = (value, record) => { this.setState({ isModalOpen: value, record: record }); }


    /***
     * 获取项目下拉列表
     */
    projectDDList = () => {
        const _this = this;
        const params = {
            'rss': 'list',
            'page_size': 65535,
            'current_index': 1
        };
        $.ajax({
            url: `${CNF.api}project/bases${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            crossDomain: true,
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    _this.setState({ projectLists: data.dat });
                }
            }
        })
    }

    /**
     * 获取列表
     */
    getLists() {
        const _this = this;
        const params = {
            'project_ulid': this.state.projectUlid,
            'start_date': this.state.startDate,
            'end_date': this.state.endDate,
            'page_size': CNF.pageSize,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}project/progressLogs${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    } else {
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    /***
    * 导出为 Excel
    */
    exportAsExecl = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '项目进度日志-' + DateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '项目进度日志明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '项目名称',
                    '项目编号',
                    '项目阶段',
                    '项目进度(%)',
                    '进度说明',
                    '记录时间',
                    '记录者'
                ],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 获取导出项目基础信息明细
     */
    export = () => {
        const _this = this;
        const params = {
            'project_ulid': this.state.projectUlid,
            'start_date': this.state.startDate,
            'end_date': this.state.endDate,
            'page_size': 65535,
            'current_index': 1
        }
        $.ajax({
            url: `${CNF.api}project/progressLogs${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        //  删除非必须字段
                        var d = [];
                        for (let i = 0; i < data.dat.length; i++) {
                            var item = data.dat[i]
                            delete item['key'];
                            delete item['create_username'];
                            delete item['create_time'];
                            delete item['update_time'];
                            delete item['node_color'];
                            d.push(item);
                        }
                        _this.exportAsExecl(d);
                    } else {
                        _this.exportAsExecl([]);
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.projectDDList();
        this.getLists();
    }

    render() {
        return (
            <>
                <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                    <Col span={isGTscreenWidth ? 5 : 6}>
                        <Select
                            showSearch
                            allowClear
                            placeholder='请选择项目'
                            style={{ width: '100%' }}
                            onChange={this.changeProjectUlid}
                            filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                        >
                            {
                                this.state.projectLists && this.state.projectLists.map((item) => {
                                    return <Option key={item.key} value={item.key}>{item.name}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={isGTscreenWidth ? 4 : 5} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <RangePicker
                            format='YYYY-MM-DD'
                            placeholder={['开始日期', '结束日期']}
                            onChange={this.changeTimeInterval}
                            style={{ width: '100%' }}
                        />
                    </Col>
                    <Space size={CNF.searchMarginLeft} style={{ marginLeft: CNF.searchMarginLeft }}>
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_export') >= 0 ? (
                                <Button
                                    title={CNF.actionName.EXPORT + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<ExportOutlined />}
                                    onClick={() => {
                                        this.export();
                                    }}>
                                    {CNF.actionName.EXPORT}
                                </Button>
                            ) : ''
                        }
                    </Space>
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            preGroup={this.props.preGroup}
                            btnLists={this.props.btnLists}
                            dataLists={this.state.dataLists}
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount}
                            changeIndex={this.changeIndex}
                            setOpen={this.setOpen}
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </>
        );
    }
}

export default CPT